import { Reveal } from "./Reveal";
import { CountUp } from "./CountUp";

export const StatsCounters = ({ counters = [] }) => (
  <section
    className="relative bg-[#050505] py-24 md:py-36 px-6 md:px-12 lg:px-24"
    data-testid="trust-stats"
  >
    <Reveal className="max-w-3xl mb-16 md:mb-24">
      <span className="font-mono text-xs tracking-[0.3em] text-[#C48A5E] uppercase">
        01 — Sistemin Ölçeği
      </span>
      <h2 className="mt-5 font-serif text-4xl md:text-6xl text-[#F5F5F0]">
        Bir gönderi değil, <span className="italic text-[#C48A5E]">mühendislik.</span>
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-14 md:gap-y-20">
      {counters.map((c, i) => (
        <Reveal key={c.key} delay={(i % 3) * 0.08} className="border-t border-[#C48A5E]/20 pt-6">
          <div className="font-mono font-bold text-[#F5F5F0] text-5xl md:text-7xl tracking-tighter">
            <CountUp to={c.value} />
          </div>
          <div className="mt-3 font-sans text-xs md:text-sm tracking-[0.15em] text-[#A3A09A] uppercase">
            {c.label}
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default StatsCounters;
